var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('div',{staticClass:"gg",on:{"click":_vm.tiaozhuan}},[_c('img',{attrs:{"src":require("../assets/shouyi2.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }